// src/auth/tokenStorage.js

import { AUTH_CONSTANTS } from "../core/constants";

const {
  TOKEN_STORAGE_KEY,
  REFRESH_TOKEN_KEY,
  USER_STORAGE_KEY,
} = AUTH_CONSTANTS;

/**
 * Save access token
 */
export const saveAccessToken = (token) => {
  localStorage.setItem(TOKEN_STORAGE_KEY, token);
};

/**
 * Get access token
 */
export const getAccessToken = () => {
  return localStorage.getItem(TOKEN_STORAGE_KEY);
};

/**
 * Remove access token
 */
export const clearAccessToken = () => {
  localStorage.removeItem(TOKEN_STORAGE_KEY);
};

/**
 * Save refresh token
 */
export const saveRefreshToken = (token) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};

/**
 * Get refresh token
 */
export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

/**
 * Remove refresh token
 */
export const clearRefreshToken = () => {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

/**
 * Save authenticated user
 */
export const saveUser = (user) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

/**
 * Get authenticated user
 */
export const getUser = () => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user ? JSON.parse(user) : null;
};

/**
 * Clear all authentication data
 */
export const clearAuthStorage = () => {
  clearAccessToken();
  clearRefreshToken();
  localStorage.removeItem(USER_STORAGE_KEY);
};